<template>
  <main-layout :selectedMenu="'home'">
    <div class="banner" :style="detail.banner | bgImageUrl"></div>

    <div class="container main">
      <div class="left">
        <div class="filter-block">
          <div class="filter-title">{{$t('global.分类')}}</div>
          <div
            class="filter-item"
            v-bind:class="{active:filterSelected==1}"
            v-on:click="filterSelected=1"
          >{{$t('global.组内成员')}}</div>
          <div
            class="filter-item"
            v-bind:class="{active:filterSelected==2}"
            v-on:click="filterSelected=2"
          >{{$t('global.加组时间')}}</div>
          <div class="filter-search">
            <input
              type="text"
              :placeholder="$t('global.频道内搜索你想找的成员')"
              class="txt-search"
              v-model="filterSearchContent"
              @keyup.enter="GetData"
            >
            <span class="iconfont icon-search" @click="GetData">&#xe614;</span>
          </div>
        </div>

        <div class="middle">
          <div class="member-list" v-if="listLength > 0">
            <el-col :span="12" v-for="(item,index) in list" :key="index">
              <div class="member-item">
                <img class="member-img" v-if="item.avatar" :src="item.avatar | imageUrl('/static/profile_img_default.png',52,52)">
                <img class="member-img" v-else src="/static/profile_img_default.png">
                <div class="member-content">
                  <div class="member-name">{{item.nickName}}</div>
                  <div class="author-title">
                    <strong v-if="item.country || item.area">{{$t('global.地区')}}：</strong>
                    {{item.country}}
                    <b v-if="item.country || item.area">,</b>
                    {{item.area}}
                  </div>
                  <div class="author-title">
                    <strong v-if="item.field">{{$t('global.领域')}}：</strong>
                    {{item.field}}
                  </div>
                  <div class="member-bottom">
                    <button
                      class="member-focus"
                      @click="Follow(item)"
                    >{{!item.isFollow?$t('global.关注'):$t('global.取消关注')}}</button>
                    <span class="member-time">{{item.joinDate}}</span>
                  </div>
                </div>
              </div>
            </el-col>
          </div>
          <content-empty v-else-if="listLength == 0" :content="$t('global.没有成员')"></content-empty>
          <pages
            :page-size="pagerParam.pageSize"
            :page-count="pagerParam.pageCount"
            :current-page="pagerParam.currentPage"
            :total="pagerParam.total"
            @current-page-changed="OnCurrentPageChanged"
          ></pages>
        </div>
      </div>
      <subject-right :detail="this.detail"></subject-right>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import pages from "../../components/pages.vue";
import SubjectRight from "../../components/SubjectRight";
import ContentEmpty from "../../components/ContentEmpty";
export default {
  name: "SubjectDetail",
  components: {
    MainLayout,
    pages,
    SubjectRight,
    ContentEmpty
  },
  data() {
    return {
      filterSelected: 1,
      filterSearchContent: "",
      detail: {},
      list: [],
      listLength: -1,
      pagerParam: {
        pageSize: 9,
        pageCount: 1,
        currentPage: 1,
        total: 1
      }
    };
  },
  created() {
    this.GetDetail();
    this.GetData();
  },
  methods: {
    Follow(item) {
      let that = this;
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
        return;
      }
      this.$http
        .post(
          `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
            item.userId
          }`
        )
        .then(function(response) {
          if (response) {
            item.isFollow = !item.isFollow;
            if (item.isFollow) {
              that.$message.success(response.message);
            } else {
              that.$message(response.message);
            }
          }
        });
    },
    GetDetail() {
      var $this = this;
      $this.$http
        .get("/api/topic/detail?topicId=" + $this.$query.id)
        .then(function(response) {
          if (response.data) {
            $this.detail = response.data;
            document.title = $this.detail.title + " | MANA";
          }
        });
    },
    GetData() {
      var $this = this;
      $this.$http
        .get(
          "/api/topic/memberList?topicId=" +
            $this.$query.id +
            "&keyword=" +
            $this.filterSearchContent +
            "&type=" +
            $this.filterSelected
        )
        .then(function(response) {
          if (response.data) {
            $this.list = response.data.list;
            $this.pagerParam = {
              pageSize: response.data.pageSize,
              pageCount: response.data.totalPage,
              currentPage: response.data.pageIndex,
              total: response.data.totalRecord
            };
            $this.listLength = $this.list.length;
          }
        });
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.GetData();
    }
  },
  watch: {
    filterSelected: function() {
      this.GetData();
    }
  }
};
</script>

<style scoped>
.banner {
  height: 6rem;
  width: 100%;
  display: block;
  background: no-repeat center center;
  background-size: cover;
}
.main {
  overflow: hidden;
  zoom: 1;
}
.left {
  width: 12rem;
  float: left;
}
.filter-block {
  margin-top: 0.4rem;
  -webkit-border-radius: 6px 6px 0 0;
  -moz-border-radius: 6px 6px 0 0;
  border-radius: 6px 6px 0 0;
  background-color: #fff;
  padding: 0.33rem 0.4rem 0.3rem;
  box-sizing: border-box;
  font-size: 0.2rem;
  color: #777;
  position: relative;
  height: 0.87rem;
  overflow: hidden;
}
.filter-title {
  padding-right: 0.55rem;
  border-right: 2px solid #ebebeb;
  display: inline-block;
  vertical-align: middle;
}
.filter-item {
  display: inline-block;
  vertical-align: middle;
  margin: 0 0.3rem 0 0.5rem;
  cursor: pointer;
  position: relative;
}
.filter-item.active {
  color: #333;
}
.filter-item.active:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -0.28rem;
  height: 0.03rem;
  background-color: #333;
  display: block;
}
.filter-search {
  position: absolute;
  right: 0.4rem;
  top: 0.2rem;
}
.txt-search {
  width: 4rem;
  height: 0.46rem;
  border: 2px solid #0060ff;
  padding: 0 0.2rem;
  -webkit-border-radius: 0.23rem;
  -moz-border-radius: 0.23rem;
  border-radius: 0.23rem;
  outline: none;
  font-size: 0.16rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  vertical-align: middle;
  color: #0060ff;
}

.icon-search {
  display: inline-block;
  width: 0.24rem;
  height: 0.24rem;
  color: #0060ff;
  margin-left: -0.44rem;
  vertical-align: middle;
  cursor: pointer;
}

.middle {
  background-color: #fff;
  margin-top: 0.2rem;
  margin-bottom: 0.8rem;
  overflow: hidden;
  zoom: 1;
  position: relative;
  clear: both;
  border-radius: 0 0 6px 6px;
}
.member-list {
  overflow: hidden;
  zoom: 1;
}
.member-item {
  padding: 0.4rem 0 0.4rem 0.4rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  zoom: 1;
}
.member-img {
  float: left;
  display: block;
  width: 1.3rem;
  height: 1.3rem;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.member-content {
  float: left;
  margin-left: 0.3rem;
  width: 4rem;
}
.member-name {
  font-size: 0.26rem;
  color: #333;
  height: 0.31rem;
}
.member-title {
  font-size: 0.16rem;
  color: #777;
  margin: 0.1rem 0 0.2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.member-focus {
  font-size: 0.16rem;
  color: #fff;
  width: 1.2rem;
  height: 0.4rem;
  text-align: center;
  line-height: 0.4rem;
  padding: 0;
  display: inline-block;
  vertical-align: middle;
  -webkit-border-radius: 0.2rem;
  -moz-border-radius: 0.2rem;
  border-radius: 0.2rem;
  background-color: #0060ff;
}
.member-time {
  font-size: 0.16rem;
  color: #777;
  margin-left: 0.2rem;
}
.member-bottom {
  margin-top: 0.1rem;
}
.author-title {
  font-size: 0.17rem;
  color: #777777;
  margin-top: 0.06rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75%;
  /* height: 0.23rem; */
}
.author-title > strong {
  color: #000;
}
.right {
  width: 3.8rem;
  margin-left: 0.2rem;
  float: left;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.right-1 {
  margin-top: 0.4rem;
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 0.3rem 0.25rem 0.4rem;
}
.right-title {
  font-size: 0.18rem;
  color: #333333;
  font-weight: bold;
  margin-left: -0.25rem;
  padding-left: 0.25rem;
  position: relative;
  margin-bottom: 0.25rem;
}
.right-title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.03rem;
  display: block;
  width: 0.06rem;
  height: 0.19rem;
  background-color: #0161ff;
  -webkit-border-radius: 0.03rem;
  -moz-border-radius: 0.03rem;
  border-radius: 0.03rem;
  margin-bottom: 0.3rem;
}
.right-subject-title {
  font-size: 0.22rem;
  color: #333;
  font-weight: bold;
}
.right-count {
  font-size: 0.14rem;
  color: #999999;
  margin: 0.07rem 0 0.12rem;
}
.right-cat {
  font-size: 0.16rem;
  color: #777777;
  margin-bottom: 0.19rem;
}
.right-author {
  line-height: 0.5rem;
  height: 0.5rem;
}
.right-author-avatar {
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  vertical-align: middle;
  margin-right: 0.2rem;
  float: left;
}
.right-author-name {
  font-size: 0.2rem;
  color: #333333;
  float: left;
}
.right-author-time {
  font-size: 0.18rem;
  color: #777;
  float: right;
}
.right-content {
  clear: both;
  font-size: 0.16rem;
  color: #777777;
  line-height: 0.3rem;
  position: relative;
}
.right-content-content {
  min-height: 0.2rem;
  display: block;
}
.right-subject-title {
  font-size: 0.22rem;
  color: #333;
  font-weight: bold;
}
.right-subject-content {
  font-size: 0.14rem;
  color: #999;
}
.right-subject-content span {
  color: #0060ff;
  display: inline-block;
  border-bottom: 1px solid #0060ff;
  margin-top: 0.05rem;
}
.right-subject-thumb {
  width: 3.3rem;
  height: 1.88rem;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  display: block;
  margin-top: 0.25rem;
}
.right-collapse {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 0.16rem;
  color: #0060ff;
  cursor: pointer;
}
.right-1-btn {
  width: 1.8rem;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0;
  display: block;
  -webkit-border-radius: 0.2rem;
  -moz-border-radius: 0.2rem;
  border-radius: 0.2rem;
  border: none;
  background-color: #0060ff;
  color: #fff;
  font-size: 0.16rem;
  font-weight: bold;
  text-align: center;
  margin: 0.2rem auto 0;
}
.right-2 {
  margin-top: 0.2rem;
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 0.3rem 0.25rem 0.2rem;
}
.right-sum {
  font-size: 0.2rem;
  font-weight: bold;
  color: #333333;
  line-height: 0.6rem;
  position: relative;
  cursor: pointer;
  margin: 0 -0.25rem;
  padding: 0 0.25rem;
}
.right-sum span {
  position: absolute;
  right: 0;
  top: 0.2rem;
}
.right-sum.active {
  background-color: #0060ff;
  color: #fff;
}
.txt-search::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #0060ff;
}

.txt-search:-moz-placeholder,
textarea:-moz-placeholder {
  color: #0060ff;
}

.txt-search::-moz-placeholder,
textarea::-moz-placeholder {
  color: #0060ff;
}

.txt-search:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #0060ff;
}
</style>



// WEBPACK FOOTER //
// src/pages/subject/SubjectMember.vue